// @generated by protoc-gen-es v1.2.0 with parameter "target=ts"
// @generated from file protos/scan/v1/scan.proto (package protos.scan.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * @generated from message protos.scan.v1.S3LogLink
 */
export class S3LogLink extends Message<S3LogLink> {
  /**
   * @generated from field: string bucket = 1;
   */
  bucket = "";

  /**
   * @generated from field: string key = 2;
   */
  key = "";

  constructor(data?: PartialMessage<S3LogLink>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protos.scan.v1.S3LogLink";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): S3LogLink {
    return new S3LogLink().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): S3LogLink {
    return new S3LogLink().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): S3LogLink {
    return new S3LogLink().fromJsonString(jsonString, options);
  }

  static equals(a: S3LogLink | PlainMessage<S3LogLink> | undefined, b: S3LogLink | PlainMessage<S3LogLink> | undefined): boolean {
    return proto3.util.equals(S3LogLink, a, b);
  }
}

/**
 * @generated from message protos.scan.v1.CreateLogLinkRequest
 */
export class CreateLogLinkRequest extends Message<CreateLogLinkRequest> {
  /**
   * @generated from field: uint64 scan_id = 1;
   */
  scanId = protoInt64.zero;

  /**
   * @generated from oneof protos.scan.v1.CreateLogLinkRequest.log_link
   */
  logLink: {
    /**
     * @generated from field: protos.scan.v1.S3LogLink s3_log_link = 2;
     */
    value: S3LogLink;
    case: "s3LogLink";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<CreateLogLinkRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protos.scan.v1.CreateLogLinkRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scan_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "s3_log_link", kind: "message", T: S3LogLink, oneof: "log_link" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateLogLinkRequest {
    return new CreateLogLinkRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateLogLinkRequest {
    return new CreateLogLinkRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateLogLinkRequest {
    return new CreateLogLinkRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateLogLinkRequest | PlainMessage<CreateLogLinkRequest> | undefined, b: CreateLogLinkRequest | PlainMessage<CreateLogLinkRequest> | undefined): boolean {
    return proto3.util.equals(CreateLogLinkRequest, a, b);
  }
}

/**
 * @generated from message protos.scan.v1.CreateLogLinkResponse
 */
export class CreateLogLinkResponse extends Message<CreateLogLinkResponse> {
  constructor(data?: PartialMessage<CreateLogLinkResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protos.scan.v1.CreateLogLinkResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateLogLinkResponse {
    return new CreateLogLinkResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateLogLinkResponse {
    return new CreateLogLinkResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateLogLinkResponse {
    return new CreateLogLinkResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateLogLinkResponse | PlainMessage<CreateLogLinkResponse> | undefined, b: CreateLogLinkResponse | PlainMessage<CreateLogLinkResponse> | undefined): boolean {
    return proto3.util.equals(CreateLogLinkResponse, a, b);
  }
}

/**
 * @generated from message protos.scan.v1.GetLogRequest
 */
export class GetLogRequest extends Message<GetLogRequest> {
  /**
   * @generated from field: uint64 scan_id = 1;
   */
  scanId = protoInt64.zero;

  constructor(data?: PartialMessage<GetLogRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protos.scan.v1.GetLogRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scan_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLogRequest {
    return new GetLogRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLogRequest {
    return new GetLogRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLogRequest {
    return new GetLogRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetLogRequest | PlainMessage<GetLogRequest> | undefined, b: GetLogRequest | PlainMessage<GetLogRequest> | undefined): boolean {
    return proto3.util.equals(GetLogRequest, a, b);
  }
}

/**
 * @generated from message protos.scan.v1.GetLogResponse
 */
export class GetLogResponse extends Message<GetLogResponse> {
  /**
   * @generated from field: uint64 scan_id = 1;
   */
  scanId = protoInt64.zero;

  /**
   * @generated from field: string log = 2;
   */
  log = "";

  constructor(data?: PartialMessage<GetLogResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protos.scan.v1.GetLogResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "scan_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "log", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetLogResponse {
    return new GetLogResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetLogResponse {
    return new GetLogResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetLogResponse {
    return new GetLogResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetLogResponse | PlainMessage<GetLogResponse> | undefined, b: GetLogResponse | PlainMessage<GetLogResponse> | undefined): boolean {
    return proto3.util.equals(GetLogResponse, a, b);
  }
}

